import {Component, HostListener, Input, OnInit} from '@angular/core';
import { Device } from '../../../../model/device';
import { Trigger } from '../../../../model/trigger';
import { SortOrder } from '../../../../model/sort-order';
import { TriggerFilters } from '../../../../model/filters/trigger-filters';
import { TriggersService } from '../../../../services/triggers.service';
import {Router} from '@angular/router';
import {CommonMessagesService} from '../../../../services/common-messages.service';
import {MessageService} from 'primeng/api';
import {TranslocoService} from '@ngneat/transloco';
import {FiltersService} from '../../../../services/filters.service';

@Component({
  selector: 'app-device-triggers',
  templateUrl: './device-triggers.component.html',
  styleUrls: ['./device-triggers.component.scss']
})
export class DeviceTriggersComponent implements OnInit {

  @Input()
  public device: Device;

  public deviceTriggers: Trigger[];
  public totalTriggers: number;
  public loadingTriggers: boolean;

  public rows = 10;
  public first = 0;


  public filtersVisible: boolean;
  public filtersFilled: boolean;
  public currentFilters: TriggerFilters;

  public activeButtonState: boolean;
  public selected: Trigger[];

  constructor(private messageService: MessageService,
              private i18n: TranslocoService,
              private triggersService: TriggersService,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<TriggerFilters>,
              private router: Router) {
    this.selected = [];
    this.activeButtonState = true;
    this.currentFilters = new TriggerFilters();
  }

  ngOnInit(): void {
    this.resetFilters();

    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));

    this.loadTriggers(this.first / this.rows, this.rows);
  }

  private loadTriggers(offset: number, limit: number): void {
    this.loadingTriggers = true;
    this.triggersService.getTriggers(offset, limit, this.currentFilters)
      .subscribe(response => {
        response.triggers.forEach((trigger: Trigger) => trigger['dataKey'] = `${trigger.name}-${trigger.device.uuid}-${trigger.ownerUuid}`);
        this.deviceTriggers = response.triggers;
        this.totalTriggers = response.totalElements;
        this.loadingTriggers = false;
        this.selected = [];
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadTriggers(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new TriggerFilters();
    this.currentFilters.entityType = 'DEVICE';
    this.currentFilters.entityUuid = this.device.uuid;
    this.filtersFilled = false;
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadTriggers(this.first / this.rows, this.rows);
  }

  edit(trigger: Trigger): void {
    this.router.navigate(['/alarms/triggers/DEVICE/' + trigger.device.uuid + '/' + trigger.deviceMeasurement.uuid + '/' + trigger.name + '/edit',
      {fromEntity: true}]);
  }

  public confirmAndDelete(trigger: Trigger): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      if (trigger.entityType === 'DEVICE') {
        this.triggersService.deleteTrigger('DEVICE', trigger.device.uuid, trigger.deviceMeasurement.uuid, trigger.name)
          .toPromise().then(() => {
          this.commonMessagesService.showSuccessfullyDeletedMessage();
          this.loadTriggers(this.first / this.rows, this.rows);
        }, error => {
          this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
        });
      }
    });
  }

  public changeActiveStates(): void {
    this.triggersService.updateTriggerState(this.selected, !this.activeButtonState).toPromise().then(() => {
      const summary = this.i18n.translate('success.generic.changesApplied');
      const detail = this.i18n.translate('success.triggers.changedState');
      this.messageService.add({severity: 'success', summary, detail});
      this.loadTriggers(this.first / this.rows, this.rows);
    });
  }

  public confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  private deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }

    const identifiers = this.selected.map(item => {
      if (item.entityType === 'DEVICE') {
        return ({
          entityType: 'DEVICE',
          entityUuid: item.device.uuid,
          entityMeasurementUuid: item.deviceMeasurement.uuid,
          triggerName: item.name
        });
      }
    });

    this.triggersService.deleteTriggers(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTriggers(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  public evaluateActiveButtonState(): void {
    let state: boolean;
    this.selected.forEach(event => {
      if (event.active === true) {
        state = true;
      } else if (event.active === false) {
        if (state === undefined) {
          state = false;
        }
      }
    });
    this.activeButtonState = !state;
  }

  public setSelectedRuleType(isUserTrigger: boolean): void {
    this.currentFilters.isUserTrigger = isUserTrigger;
  }

  @HostListener('window:keyup', ['$event'])
  public keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
